import styled from 'styled-components'
import {
  RichTextDefaults,
  TableWrapper,
  UnorderedList,
} from '@components/RichText/index.style'
import { clamp } from '@styles/utils/conversion.style'
import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'
import {
  Caption,
  Heading3Serif,
  Label,
  TextBody,
} from '@styles/vars/textStyles.style'
import { grid } from '@styles/vars/grid.style'
import { GalleryMain } from '@components/Gallery/index.style'
import { VideoMain } from '@components/Video/index.style'
import { AnimateSlideInContent } from '@components/animation/AnimateSlideIn/index.style'

export const ContentMain = styled.div`
  background-color: ${colors.white};
  .privacy-policy ${TextBody} {
    font-size: ${19.5 / 10}rem;
  }
  table {
    width: 100%;
    p br {
      display: none;
    }
  }
  .cookie-policy {
    ${mq.tabletL} {
      td:last-child{
        min-width: 140px;
      }
    }
  }
  .main-grid-side {
    background-color: ${colors.pastelOrange};
  }
  ${mq.tabletPMax} {
    .main-grid-side {
      margin-left: -22px;
      margin-right: -22px;
    }
  }
  ${mq.tabletL} {
    .main-grid {
      margin-left: -40px;
      margin-right: -40px;
    }
    .main-grid-content {
      padding-left: 40px;
    }
  }
`
export const PdfFormContainer = styled.div`
  ${clamp('margin-left', -50, 0)}
`
export const ContentOutputWithForm = styled.div`
  display: grid;
  grid-template-columns: repeat(${grid.columnCount}, 1fr);
  ${clamp('grid-column-gap', grid.gap.min, grid.gap.max)}

  ${RichTextDefaults}

  > * {
    grid-column: 1 / span 14;
  }
  
  > br {
    display:none;
  }
  p br:last-child{
    display:none;
  }

  > h2,
  > h3,
  > h4 {
  }

  *
    + ${TextBody},
    *
    + ${UnorderedList},
    *
    + ${Caption},
    *
    + ${Label},
    *
    + ${TableWrapper} {
    ${clamp('margin-top', 20, 40)}
  }

  * + h2 {
    margin-top: 1.875em;
  }

  * + h3 {
    margin-top: 0.9523809524em;
  }

  ${Heading3Serif} + * {
    margin-top: 2rem;
  }

  *
    + ${AnimateSlideInContent},
    *
    + ${GalleryMain},
    *
    + ${VideoMain},
    *
    + .gatsby-image-wrapper {
    ${clamp('margin-top', 30, 60)}
  }
`
export const ContentOutput = styled.div`
  display: grid;
  grid-template-columns: repeat(${grid.columnCount}, 1fr);
  ${clamp('grid-column-gap', grid.gap.min, grid.gap.max)}

  ${RichTextDefaults}

  > br {
    display:none;
  }

  > * {
    grid-column: 1 / span 14;

    ${mq.tabletL} {
      grid-column: 3 / span 10;
    }
  }

  > h2,
  > h3,
  > h4 {
    ${mq.tabletL} {
      grid-column: 3 / span 8;
    }
  }

  *
    + ${TextBody},
    *
    + ${UnorderedList},
    *
    + ${Caption},
    *
    + ${Label},
    *
    + ${TableWrapper} {
    ${clamp('margin-top', 20, 40)}
  }
  

  * + h2 {
    margin-top: 1.875em;
  }

  * + h3 {
    margin-top: 0.9523809524em;
  }

  ${Heading3Serif} + * {
    margin-top: 2rem;
  }

  *
    + ${AnimateSlideInContent},
    *
    + ${GalleryMain},
    *
    + ${VideoMain},
    *
    + .gatsby-image-wrapper {
    ${clamp('margin-top', 30, 60)}
  }
`